var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-client white-bg"},[_c('div',{staticClass:"client-img"},[_vm._t("cardMedia")],2),_vm._v(" "),_c('div',{staticClass:"client-info"},[_c('div',{staticClass:"client-name iq-mb-10"},[_vm._t("cardHeader")],2),_vm._v(" "),_vm._t("cardBody")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }